module.exports = __webpack_public_path__ + "static/media/unpivot-data-icon.cbbf20d6.svg";